// 결제 페이지 메인임
// 여기서도 라우팅 해야함

import { Routes, Route, Navigate } from "react-router-dom";
import PaymentMainPage from "./MainPage";
import paymentHeader from "../../assets/images/payment/payment_header.webp";
import PaymentFlowPage from "./PaymentFlowPage";
import Footer from "../../components/Footer";

function PaymentPage() {
  return (
    <div className="min-h-screen flex flex-col  mx-auto bg-[#F9F9FC]">
      <header className="w-full max-w-[716px] mx-auto">
        <img src={paymentHeader} alt="logo" className="w-full" />
      </header>
      <main className="flex-1 mx-auto w-full">
        <Routes>
          {/*  결제 메인 페이지 */}
          <Route index element={<PaymentMainPage />} />
          {/* 사주정보 입력 페이지 */}
          <Route path="/info/:type" element={<PaymentFlowPage />} />
          {/* 결제 실패 페이지 */}
          <Route path="/fail" element={<div>결제 실패 페이지</div>} />
          {/* 결제 성공 페이지 */}
          <Route path="/complete" element={<div>결제 성공 페이지</div>} />
          {/* 그외의 경로 처리 */}
          <Route path="*" element={<Navigate to="/payment" />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default PaymentPage;
